import { render, staticRenderFns } from "./ManageCitiesContainer.vue?vue&type=template&id=dd6d45f8&"
import script from "./ManageCitiesContainer.vue?vue&type=script&lang=js&"
export * from "./ManageCitiesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports